<div class="ref-data-container">
    <div class="row">
        <!-- REF DATA LABEL -->
        <div class="col-4">
            {{ refData.label }}
        </div>
        <!-- REF DATA INPUT -->
        <div class="col-6">
            @if (type !== 'select') {
                <!-- TEXT OR NUMBER REF DATA TYPE -->
                <input
                    nbInput
                    type="{{ type }}"
                    fullWidth
                    #input
                    value="{{ value }}"
                    (keyup)="valueChanged(input.value)"
                    (change)="valueChanged(input.value)"
                    [disabled]="disabled"
                    [nbTooltipDisabled]="!value || !disabled"
                    nbTooltip="{{ value }}"
                    nbTooltipStatus="basic"
                    nbTooltipPlacement="bottom"
                    placeholder="-"
                >
            } @else {
                <!-- FOREIGN KEY OR USER REF DATA TYPE -->
                <nb-select
                    selected="{{ value }}"
                    [disabled]="disabled"
                    (selectedChange)="valueChanged($event)"
                >
                    @for (option of options; track option.id) {
                        <nb-option value="{{ option.id }}">{{ option.label }}</nb-option>
                    }
                </nb-select>
            }
        </div>
        <!-- REF DATA SOURCE -->
        @if (refData.tooltip) {
            <div class="col-2">
                <span class="source"
                    [nbTooltip]="refData.tooltip"
                    nbTooltipStatus="basic"
                    nbTooltipPlacement="right"
                >
                    {{ "Source" | translate }}
                </span>
            </div>
        }
    </div>
</div>